import { all, takeEvery, call, put } from "redux-saga/effects";
import { detail } from "services/apis/monitoringDisplayProfile";
import actions from "./actions";

function* loading(isLoading = false, error = false) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: isLoading,
      error,
    },
  });
}

export function* DETAIL({ payload }) {
  const { id, filter } = payload;
  yield loading(true);

  const response = yield call(detail, id, filter);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
        error: false,
      },
    });
  }

  if (!response) {
    yield loading(false, true);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.DETAIL, DETAIL)]);
}
